import { useEffect, useState } from 'react';

import bgPremium from '@/assets/bg_boxpremium--default.jpg';
import bgPremium2x from '@/assets/bg_boxpremium--default@2x.jpg';
import bgPremiumTeam11 from '@/assets/bg_boxpremium--team11.jpg';
import bgPremium2xTeam11 from '@/assets/bg_boxpremium--team11@2x.jpg';
import bgCDA from '@/assets/tournaments/bg_cda-home.jpg';
import bgChallenge from '@/assets/tournaments/bg_challenge.jpg';
import bgGoldDateMainBox from '@/assets/tournaments/bg_goldDate-mainbox.jpg';
import bgMLDisabled from '@/assets/tournaments/bg_ml-home-disabled.jpg';
import bgML from '@/assets/tournaments/bg_ml-home.jpg';
import bgTDA from '@/assets/tournaments/bg_tda-home.jpg';
import { EnumContextGDT, EnumTeamContext } from '@/types/team';

interface ContextData {
  bg: string;
  bg2x?: string;
}

// Definimos todos los datos de contexto posibles
const DATA_CONTEXT: Partial<
  Record<EnumContextGDT | EnumTeamContext, ContextData>
> = {
  [EnumContextGDT.FriendTournament]: {
    bg: bgTDA,
  },
  [EnumContextGDT.FriendsCup]: {
    bg: bgCDA,
  },
  [EnumContextGDT.Minileagues]: {
    bg: bgML,
  },
  [EnumContextGDT.MinileaguesDisabled]: {
    bg: bgMLDisabled,
  },
  [EnumContextGDT.MiniLeaguesInProgress]: {
    bg: bgMLDisabled, // bgMLInProgress
  },
  [EnumContextGDT.GoldDate]: {
    bg: bgGoldDateMainBox,
  },
  [EnumContextGDT.Challenge]: {
    bg: bgChallenge,
  },
  [EnumContextGDT.Summary]: {
    bg: bgPremium,
    bg2x: bgPremium2x,
  },
  [EnumTeamContext.Team11]: {
    bg: bgPremiumTeam11,
    bg2x: bgPremium2xTeam11,
  },
  [EnumTeamContext.Team5]: {
    bg: bgPremium2x,
    bg2x: bgPremium2x,
  },
};

interface Props {
  context?: EnumContextGDT | EnumTeamContext;
}

export const useBackgroundByContext = ({
  context = EnumContextGDT.FriendTournament,
}: Props) => {
  const [state, setState] = useState<ContextData | null>({
    bg: '',
  });

  useEffect(() => {
    const data = DATA_CONTEXT[context];
    if (data) {
      setState({ bg: data.bg, ...(data.bg2x && { bg2x: data.bg2x }) });
    } else {
      setState(null);
    }
  }, [context]);

  if (!state) {
    return null;
  }

  return { default: state.bg, retina: state.bg2x };
};
